import styled from "styled-components/macro"

export const GalleryScreen = styled.div`
  background-color: ${({
    theme: {
      palette: { galleryBG }
    }
  }) => galleryBG};
  width: 100%;
  height: 100%;
`
